module.exports = __webpack_public_path__ + "static/media/gb-nir.2e9c71c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gb-nir.svg
// module id = 119
// module chunks = 0